import React, { ReactNode } from 'react';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import './DocumentCard.less';

type textColorType =
  | 'white'
  | 'primary'
  | 'blue'
  | 'indicator-neutral'
  | 'dark-10'
  | 'dark-20'
  | 'dark-30'
  | 'dark-50'
  | 'dark-100';

type textSizeType = 1 | 2 | 3 | 4;

type positionYType = 'center';

export type DocumentCardType = {
  title: ReactNode;
  titlefontWeight?: 'bold';
  active?: boolean;
  hover?: boolean;
  background?: 'strong' | 'soft';
  date?: ReactNode;
  titleColor?: textColorType;
  uploaderColor?: textColorType;
  titleSize?: textSizeType;
  uploaderSize?: textSizeType;
  iconPositionY?: positionYType;
  actionsPositionY?: positionYType;
  uploader?: string;
  icon?: ReactNode;
  onItemClick?: React.MouseEventHandler<HTMLDivElement>;
  actions?: {
    type: string;
    render: ReactNode;
    icon: ReactNode;
    onClick: React.MouseEventHandler<HTMLDivElement>;
  }[];
};
const DocumentCard: React.FC<DocumentCardType> = ({
  title,
  titlefontWeight = false,
  uploader,
  icon,
  actions = [],
  onItemClick,
  date = '',
  active,
  background,
  titleColor,
  uploaderColor,
  titleSize = 2,
  uploaderSize = 3,
  actionsPositionY,
  hover = false,
}) => {
  const classNames: String[] = ['document-card-container'];
  if (active) {
    classNames.push('document-card-container-active');
  }
  if (background) {
    classNames.push(`document-card-container-${background}`);
  }
  if (hover) {
    classNames.push(`document-card-container-hover`);
  }

  return (
    <div className={classNames.join(' ')} onClick={onItemClick}>
      <Wrapper display="flex" justifyContent="space-between">
        <Wrapper display="flex">
          {icon && (
            <Wrapper display="flex" pr={1} mt={3}>
              {icon}
            </Wrapper>
          )}
          <Wrapper>
            <Text
              level={titleSize}
              rows={1}
              semiBold={titlefontWeight === 'bold'}
              textColor={titleColor}
            >
              {title}
            </Text>
            <div className="uploader">
              {uploader && (
                <Text textColor={uploaderColor} level={uploaderSize} rows={1}>
                  {uploader}
                </Text>
              )}
            </div>
            <div className="date">
              <Text textColor={uploaderColor} level={uploaderSize} rows={1}>
                {date}
              </Text>
            </div>
          </Wrapper>
        </Wrapper>
        {!!actions.length && (
          <Wrapper display="flex" alignItems={actionsPositionY}>
            <div className="actions-wrapper">
              {actions.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="action-wrapper"
                    onClick={item.onClick}
                  >
                    {item.icon}
                  </div>
                );
              })}
            </div>
          </Wrapper>
        )}
      </Wrapper>
    </div>
  );
};

export default DocumentCard;
